// Global target-region dataset for the Audience step of the Campaign Builder.
// Used as an in-bundle typeahead source — no network call needed.
// Coverage mirrors the Programmatic Panel Network's supported countries/metros (100+ countries).
// Atlantic Canada cities are listed first because the internal panel hub is there.
// Province/State and country names are included so a client can also target broadly.

export const GLOBAL_REGIONS = [
  // ---------- ATLANTIC CANADA (internal panel hub) ----------
  "Halifax Regional Municipality, NS",
  "Dartmouth, NS",
  "Sydney, NS",
  "Nova Scotia",
  "Moncton, NB",
  "Saint John, NB",
  "Fredericton, NB",
  "New Brunswick",
  "St. John's, NL",
  "Newfoundland and Labrador",
  "Charlottetown, PE",
  "Summerside, PE",
  "Prince Edward Island",

  // ---------- CANADA — major metros + provinces ----------
  "Toronto, ON", "Mississauga, ON", "Brampton, ON", "Hamilton, ON",
  "Ottawa, ON", "London, ON", "Kitchener-Waterloo, ON", "Windsor, ON", "Ontario",
  "Montreal, QC", "Quebec City, QC", "Laval, QC", "Gatineau, QC", "Sherbrooke, QC", "Quebec",
  "Vancouver, BC", "Surrey, BC", "Burnaby, BC", "Victoria, BC", "Kelowna, BC", "British Columbia",
  "Calgary, AB", "Edmonton, AB", "Red Deer, AB", "Lethbridge, AB", "Alberta",
  "Winnipeg, MB", "Brandon, MB", "Manitoba",
  "Saskatoon, SK", "Regina, SK", "Saskatchewan",
  "Yellowknife, NT", "Whitehorse, YT", "Iqaluit, NU",
  "Canada",

  // ---------- UNITED STATES — top metros + states ----------
  "New York City, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX",
  "Phoenix, AZ", "Philadelphia, PA", "San Antonio, TX", "San Diego, CA",
  "Dallas, TX", "Austin, TX", "San Jose, CA", "Fort Worth, TX",
  "Jacksonville, FL", "Columbus, OH", "Charlotte, NC", "Indianapolis, IN",
  "San Francisco, CA", "Seattle, WA", "Denver, CO", "Washington, DC",
  "Boston, MA", "El Paso, TX", "Nashville, TN", "Detroit, MI",
  "Oklahoma City, OK", "Portland, OR", "Las Vegas, NV", "Memphis, TN",
  "Louisville, KY", "Baltimore, MD", "Milwaukee, WI", "Albuquerque, NM",
  "Tucson, AZ", "Fresno, CA", "Sacramento, CA", "Kansas City, MO",
  "Mesa, AZ", "Atlanta, GA", "Omaha, NE", "Colorado Springs, CO",
  "Raleigh, NC", "Miami, FL", "Long Beach, CA", "Virginia Beach, VA",
  "Oakland, CA", "Minneapolis, MN", "Tulsa, OK", "Arlington, TX",
  "Tampa, FL", "New Orleans, LA",
  "California", "Texas", "Florida", "New York", "Pennsylvania", "Illinois",
  "Ohio", "Georgia", "North Carolina", "Michigan", "New Jersey", "Virginia",
  "Washington State", "Arizona", "Massachusetts", "Tennessee", "Indiana",
  "Missouri", "Maryland", "Wisconsin", "Colorado", "Minnesota", "South Carolina",
  "Alabama", "Louisiana", "Kentucky", "Oregon", "Oklahoma", "Connecticut",
  "Utah", "Iowa", "Nevada", "Arkansas", "Mississippi", "Kansas", "New Mexico",
  "Nebraska", "Idaho", "West Virginia", "Hawaii", "New Hampshire", "Maine",
  "Montana", "Rhode Island", "Delaware", "South Dakota", "North Dakota",
  "Alaska", "Vermont", "Wyoming",
  "United States",

  // ---------- UK & IRELAND ----------
  "London, UK", "Birmingham, UK", "Manchester, UK", "Leeds, UK",
  "Liverpool, UK", "Sheffield, UK", "Bristol, UK", "Newcastle, UK",
  "Nottingham, UK", "Southampton, UK", "Cardiff, UK", "Edinburgh, UK",
  "Glasgow, UK", "Belfast, UK",
  "England", "Scotland", "Wales", "Northern Ireland", "United Kingdom",
  "Dublin, IE", "Cork, IE", "Galway, IE", "Ireland",

  // ---------- EUROPE — major metros + countries ----------
  "Paris, FR", "Marseille, FR", "Lyon, FR", "Toulouse, FR", "Nice, FR",
  "Nantes, FR", "Strasbourg, FR", "Bordeaux, FR", "Lille, FR", "France",
  "Berlin, DE", "Munich, DE", "Hamburg, DE", "Frankfurt, DE", "Cologne, DE",
  "Stuttgart, DE", "Düsseldorf, DE", "Leipzig, DE", "Dortmund, DE", "Germany",
  "Madrid, ES", "Barcelona, ES", "Valencia, ES", "Seville, ES", "Bilbao, ES", "Spain",
  "Rome, IT", "Milan, IT", "Naples, IT", "Turin, IT", "Florence, IT",
  "Bologna, IT", "Venice, IT", "Italy",
  "Amsterdam, NL", "Rotterdam, NL", "The Hague, NL", "Utrecht, NL",
  "Eindhoven, NL", "Netherlands",
  "Brussels, BE", "Antwerp, BE", "Ghent, BE", "Belgium",
  "Vienna, AT", "Graz, AT", "Salzburg, AT", "Austria",
  "Zurich, CH", "Geneva, CH", "Bern, CH", "Basel, CH", "Switzerland",
  "Lisbon, PT", "Porto, PT", "Portugal",
  "Athens, GR", "Thessaloniki, GR", "Greece",
  "Warsaw, PL", "Krakow, PL", "Łódź, PL", "Wrocław, PL", "Poznań, PL",
  "Gdańsk, PL", "Poland",
  "Prague, CZ", "Brno, CZ", "Czech Republic",
  "Budapest, HU", "Debrecen, HU", "Hungary",
  "Bucharest, RO", "Cluj-Napoca, RO", "Romania",
  "Sofia, BG", "Bulgaria",
  "Bratislava, SK", "Slovakia",
  "Ljubljana, SI", "Slovenia",
  "Zagreb, HR", "Split, HR", "Croatia",
  "Belgrade, RS", "Serbia",
  "Stockholm, SE", "Gothenburg, SE", "Malmö, SE", "Sweden",
  "Oslo, NO", "Bergen, NO", "Trondheim, NO", "Norway",
  "Copenhagen, DK", "Aarhus, DK", "Denmark",
  "Helsinki, FI", "Espoo, FI", "Tampere, FI", "Finland",
  "Reykjavik, IS", "Iceland",
  "Tallinn, EE", "Estonia",
  "Riga, LV", "Latvia",
  "Vilnius, LT", "Lithuania",
  "Luxembourg City, LU", "Luxembourg",
  "Valletta, MT", "Malta",
  "Nicosia, CY", "Cyprus",
  "Kyiv, UA", "Kharkiv, UA", "Lviv, UA", "Ukraine",

  // ---------- LATIN AMERICA ----------
  "Mexico City, MX", "Guadalajara, MX", "Monterrey, MX", "Puebla, MX",
  "Tijuana, MX", "Cancún, MX", "Mexico",
  "São Paulo, BR", "Rio de Janeiro, BR", "Brasília, BR", "Salvador, BR",
  "Fortaleza, BR", "Belo Horizonte, BR", "Curitiba, BR", "Porto Alegre, BR",
  "Recife, BR", "Brazil",
  "Buenos Aires, AR", "Córdoba, AR", "Rosario, AR", "Mendoza, AR", "Argentina",
  "Santiago, CL", "Valparaíso, CL", "Chile",
  "Bogotá, CO", "Medellín, CO", "Cali, CO", "Cartagena, CO", "Colombia",
  "Lima, PE", "Arequipa, PE", "Peru",
  "Caracas, VE", "Venezuela",
  "Quito, EC", "Guayaquil, EC", "Ecuador",
  "Montevideo, UY", "Uruguay",
  "Asunción, PY", "Paraguay",
  "La Paz, BO", "Santa Cruz, BO", "Bolivia",
  "San José, CR", "Costa Rica",
  "Panama City, PA", "Panama",
  "Guatemala City, GT", "Guatemala",
  "San Salvador, SV", "El Salvador",
  "Tegucigalpa, HN", "Honduras",
  "Managua, NI", "Nicaragua",
  "Santo Domingo, DO", "Dominican Republic",
  "Havana, CU", "Cuba",
  "Kingston, JM", "Jamaica",
  "San Juan, PR", "Puerto Rico",
  "Port-au-Prince, HT", "Haiti",

  // ---------- ASIA — major metros + countries ----------
  "Tokyo, JP", "Osaka, JP", "Yokohama, JP", "Nagoya, JP", "Sapporo, JP",
  "Fukuoka, JP", "Kobe, JP", "Kyoto, JP", "Japan",
  "Seoul, KR", "Busan, KR", "Incheon, KR", "Daegu, KR", "South Korea",
  "Beijing, CN", "Shanghai, CN", "Shenzhen, CN", "Guangzhou, CN",
  "Chengdu, CN", "Hangzhou, CN", "Wuhan, CN", "Xi'an, CN", "Chongqing, CN",
  "Tianjin, CN", "China",
  "Hong Kong", "Macau", "Taipei, TW", "Kaohsiung, TW", "Taiwan",
  "Singapore",
  "Kuala Lumpur, MY", "George Town, MY", "Johor Bahru, MY", "Malaysia",
  "Jakarta, ID", "Surabaya, ID", "Bandung, ID", "Medan, ID", "Bali, ID", "Indonesia",
  "Manila, PH", "Quezon City, PH", "Cebu, PH", "Davao, PH", "Philippines",
  "Bangkok, TH", "Chiang Mai, TH", "Phuket, TH", "Pattaya, TH", "Thailand",
  "Hanoi, VN", "Ho Chi Minh City, VN", "Da Nang, VN", "Vietnam",
  "Phnom Penh, KH", "Cambodia",
  "Vientiane, LA", "Laos",
  "Yangon, MM", "Myanmar",
  "Mumbai, IN", "Delhi, IN", "Bangalore, IN", "Hyderabad, IN", "Chennai, IN",
  "Kolkata, IN", "Pune, IN", "Ahmedabad, IN", "Jaipur, IN", "Lucknow, IN",
  "Kanpur, IN", "Nagpur, IN", "Surat, IN", "Indore, IN", "Chandigarh, IN",
  "Kochi, IN", "Goa, IN", "India",
  "Karachi, PK", "Lahore, PK", "Islamabad, PK", "Faisalabad, PK", "Pakistan",
  "Dhaka, BD", "Chittagong, BD", "Bangladesh",
  "Colombo, LK", "Sri Lanka",
  "Kathmandu, NP", "Nepal",
  "Thimphu, BT", "Bhutan",
  "Malé, MV", "Maldives",
  "Ulaanbaatar, MN", "Mongolia",
  "Almaty, KZ", "Nur-Sultan, KZ", "Kazakhstan",
  "Tashkent, UZ", "Uzbekistan",

  // ---------- MIDDLE EAST ----------
  "Dubai, AE", "Abu Dhabi, AE", "Sharjah, AE", "United Arab Emirates",
  "Riyadh, SA", "Jeddah, SA", "Mecca, SA", "Medina, SA", "Dammam, SA", "Saudi Arabia",
  "Doha, QA", "Qatar",
  "Kuwait City, KW", "Kuwait",
  "Manama, BH", "Bahrain",
  "Muscat, OM", "Oman",
  "Tel Aviv, IL", "Jerusalem, IL", "Haifa, IL", "Israel",
  "Amman, JO", "Jordan",
  "Beirut, LB", "Lebanon",
  "Istanbul, TR", "Ankara, TR", "Izmir, TR", "Bursa, TR", "Antalya, TR", "Turkey",
  "Tehran, IR", "Mashhad, IR", "Isfahan, IR", "Iran",
  "Baghdad, IQ", "Iraq",

  // ---------- AFRICA ----------
  "Cairo, EG", "Alexandria, EG", "Giza, EG", "Egypt",
  "Lagos, NG", "Abuja, NG", "Kano, NG", "Ibadan, NG", "Port Harcourt, NG", "Nigeria",
  "Johannesburg, ZA", "Cape Town, ZA", "Durban, ZA", "Pretoria, ZA", "South Africa",
  "Nairobi, KE", "Mombasa, KE", "Kenya",
  "Addis Ababa, ET", "Ethiopia",
  "Accra, GH", "Kumasi, GH", "Ghana",
  "Dakar, SN", "Senegal",
  "Abidjan, CI", "Côte d'Ivoire",
  "Casablanca, MA", "Rabat, MA", "Marrakesh, MA", "Morocco",
  "Algiers, DZ", "Oran, DZ", "Algeria",
  "Tunis, TN", "Tunisia",
  "Tripoli, LY", "Libya",
  "Khartoum, SD", "Sudan",
  "Kampala, UG", "Uganda",
  "Dar es Salaam, TZ", "Tanzania",
  "Kigali, RW", "Rwanda",
  "Lusaka, ZM", "Zambia",
  "Harare, ZW", "Zimbabwe",
  "Maputo, MZ", "Mozambique",
  "Luanda, AO", "Angola",
  "Yaoundé, CM", "Douala, CM", "Cameroon",
  "Antananarivo, MG", "Madagascar",

  // ---------- OCEANIA ----------
  "Sydney, AU", "Melbourne, AU", "Brisbane, AU", "Perth, AU", "Adelaide, AU",
  "Gold Coast, AU", "Canberra, AU", "Newcastle, AU", "Hobart, AU", "Darwin, AU",
  "New South Wales", "Victoria, Australia", "Queensland", "Western Australia",
  "South Australia", "Tasmania",
  "Australia",
  "Auckland, NZ", "Wellington, NZ", "Christchurch, NZ", "Hamilton, NZ",
  "Tauranga, NZ", "Dunedin, NZ", "New Zealand",
  "Suva, FJ", "Fiji",
  "Port Moresby, PG", "Papua New Guinea",
];

// Atlantic-Canada detection — used to gate the Internal Panel slider since
// our internal panelist hub only covers the Atlantic provinces.
const ATLANTIC_KEYWORDS = [
  "halifax", "dartmouth", "sydney, ns", "nova scotia", " ns",
  "moncton", "saint john", "fredericton", "new brunswick", " nb",
  "st. john", "st john's", "newfoundland", "labrador", " nl",
  "charlottetown", "summerside", "prince edward island", "pei", " pe",
  "atlantic",
];
export const isAtlanticRegion = (r) => {
  if (!r) return true;
  const s = r.trim().toLowerCase();
  return ATLANTIC_KEYWORDS.some((k) => s.includes(k));
};
